const Scope = Object.freeze({
    COLLECTION_READ: 'collection:read',
    COLLECTION_ACCOUNT_READ: 'collection.account:read',
    COLLECTION_CREDIT_REPORTING_READ: 'collection.credit_reporting:read',
    COLLECTION_SETTING_READ: 'collection.setting:read',
});

export default Scope;
